import * as React from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { Breadcrumb, Heading } from 'vet-bones/design-system/components';

import { Loading } from 'src/ui/components/Loading';
import {
  ORGANIZATION_DASHBOARD_BREADCRUMB_ORG,
  ORGANIZATION_SDU_DASHBOARD_BREADCRUMB_UNITS,
  ORGANIZATION_SDU_DASHBOARD_ENDPOINT_HEADING,
} from 'src/ui/constants/testIds';
import { SduDashboardBody } from 'src/ui/containers/sdu-dashboard/SduDashboardBody';
import { SduEndpointActionMenu } from 'src/ui/containers/sdu-dashboard/SduEndpointActionMenu';
import { graphQLClient } from 'src/ui/graph/graphQLClient';
import { useListOrganizationConnectionsQuery } from 'src/ui/graph/types';
import { useOrganization } from 'src/ui/hooks/organization';
import * as copy from 'src/ui/templates/copy';
import { buildDashboardRoute } from 'src/ui/utils/buildRoute';

export const OrganizationSduDashboardEndpoint: React.VFC = () => {
  const history = useHistory();
  const { org, id } = useParams<{ org: string; id: string }>();

  const { organization } = useOrganization(org);

  const { data, isLoading } = useListOrganizationConnectionsQuery(
    graphQLClient,
    { org_domain: org }
  );

  const connection = React.useMemo(
    () => data?.listConnections?.find((conn) => conn?.index?.toString() === id),
    [data?.listConnections, id]
  );

  if (isLoading) {
    return <Loading />;
  }

  if (!connection) {
    return <Redirect to={buildDashboardRoute(org, 'units')} />;
  }

  if (!organization) {
    return null;
  }

  return (
    <div className="organization-dashboard">
      <div className="organization-dashboard-header">
        <div className="organization-dashboard-header-info">
          <Heading
            size="xl"
            testId={ORGANIZATION_SDU_DASHBOARD_ENDPOINT_HEADING}
            weight="semibold"
          >
            {organization.name}
          </Heading>
          <Breadcrumb
            items={[
              {
                id: 'org',
                onClick: () => history.push(buildDashboardRoute(org)),
                testId: ORGANIZATION_DASHBOARD_BREADCRUMB_ORG,
                text: organization.name,
              },
              {
                id: 'units',
                onClick: () => history.push(buildDashboardRoute(org, 'units')),
                testId: ORGANIZATION_SDU_DASHBOARD_BREADCRUMB_UNITS,
                text: copy.components.organization.dashboard.breadcrumb.units,
              },
              {
                id: 'endpoint',
                text: connection.name,
              },
            ]}
          />
        </div>
        <div className="organization-dashboard-header-actions">
          <SduEndpointActionMenu connection={connection} />
        </div>
      </div>

      <SduDashboardBody connectionId={connection.id} orgDomain={org} />
    </div>
  );
};
